import { PresenceTypeEnum } from '@/types/presences';
import { EVisibility } from '@/types/types';

export enum TimeKeepingButtonStateEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type TimeKeepingRecords = {
  id?: string;
  visibility: EVisibility;
  datetimeStart: Date | string;
  datetimeEnd: Date | string;
};

export type TimeKeepingSupportRegistry = {
  presenceId: string;
  records: TimeKeepingRecords[];
};

export type ItemLayoutType = {
  presence_type: PresenceTypeEnum;
  presence_id: string;
  supports: TimeKeepingSupportRegistry[];
  records?: TimeKeepingRecords[];
  x: number;
  y: number;
  w: number;
  h: number;
  min_w: number;
  max_w: number;
  min_h: number;
};

export type TSessionLogo = {
  id: string;
  supports: string[];
};

export type TimeKeepingSessionPostData = {
  name: string;
  workspaces: string[];
  logos: TSessionLogo[];
  people: string[];
  layout: Omit<ItemLayoutType, 'supports' | 'records'>[];
};

export type TimeKeepingSessionNote = {
  clip_id: string;
  note: string;
};

export type TimeKeepingSession = {
  workspaces: string[];
  id: string;
  name: string;
  logos: TSessionLogo[];
  people: string[];
  layout: Omit<ItemLayoutType, 'supports' | 'records'>[];
  notes?: TimeKeepingSessionNote[];
};

export type TimeKeepingDashboardHandle = {
  getLayout: () => { i: string; x: number; y: number; w: number; h: number }[];
  getCols: () => number;
};
